<template>
  <div class="fixed inset-0 z-50 overflow-auto" v-if="open">
    <div class="flex h-full min-h-screen items-center justify-center text-center">
      <transition
        v-on:enter="fadeEnter"
        v-on:leave="fadeLeave"
        v-bind:css="false"
        :appear="$screen.portrait ? false : true"
      >
        <div v-if="open" class="flex h-full w-full items-center justify-center">
          <div @click="$emit('close')" class="fixed inset-0 flex items-center justify-center transition-opacity">
            <div
              class="bg-ontick-steel-500 dark:bg-ontick-graphite-700 absolute inset-0 overflow-hidden opacity-75"
            ></div>
          </div>

          <span class="hidden"></span>&#8203;

          <!-- <transition
            v-on:enter="enter"
            v-on:leave="leave"
            v-bind:css="false"
            appear
          > -->
          <!-- Default: w-2/4 -->
          <!-- Modificado: w-3/4 -->
          <div
            v-if="open"
            :class="[
              sizeModal,
              bgClass,
              'duration-400 inline-block max-h-full transform overflow-y-auto\trounded-lg px-4 pt-5 pb-4 text-left align-middle shadow transition-transform ease-in sm:my-8 sm:p-4',
            ]"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="w-full">
              <div class="flex w-full items-center justify-between">
                <ontick-card-title v-if="title">{{ title }}</ontick-card-title>
                <button
                  v-show="!fixed && showCloseButton"
                  type="button"
                  class="hover:bg-ontick-nineth bg-ontick-steel-200 text-ontick-steel-900 dark:bg-ontick-graphite-800 ml-auto rounded-full p-1 transition duration-150 ease-in-out hover:text-white focus:text-white focus:outline-none dark:text-white"
                  aria-label="Close"
                  @click="$emit('close')"
                >
                  <!-- Heroicon name: x -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div class="mt-0">
                <slot></slot>
              </div>
              <slot name="footer"></slot>
            </div>
          </div>
          <!-- </transition> -->
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "ontick-modal",
  props: {
    title: {
      type: String,
    },
    open: {
      type: Boolean,
      default: false,
    },
    fixed: { type: Boolean, default: false },
    size: {
      type: String,
      default: "normal",
      validator: function (value) {
        return ["xs", "small", "normal", "large", "medium", "dynamic", "custom"].indexOf(value) !== -1;
      },
    },
    customSizeClass: {
      type: String,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    bgClass: {
      type: String,
      default: "dark:bg-ontick-graphite-500 bg-gray-50",
    },
  },

  computed: {
    sizeModal() {
      const sizes = {
        xs: "w-full sm:w-3/6 lg:w-2/6 xl:w-1/5",
        small: "w-full sm:w-4/5 lg:w-3/6 xl:w-2/5",
        normal: "w-full sm:w-4/5 md:w-1/2",
        large: "w-full md:w-3/4 w-4/5",
        medium: "xl:w-2/5 md:w-4/5 lg:w-3/2",
        custom: this.customSizeClass,
      };
      return sizes[this.size];
    },
  },

  methods: {
    fadeEnter(el, done) {
      TweenMax.fromTo(
        el,
        0.8,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    fadeLeave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        y: window.innerWidth * 0.3,
        scale: 1,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.3, {
        y: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.3, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.to(el, 0.5, {
        y: window.innerHeight * 0.3,
        ease: Power4.easeOut,
        onComplete: done,
      });
    },
  },
};
</script>
